import SelectFundTable from "./SelectFundTable";

export default SelectFundTable;
